export default __webpack_public_path__ + "static/media/shopMens.ec1029f6.jpg";